"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CantataOfTaluviasAbilityHandler = exports.CantataOfTaluviasActorAbilityFactory = exports.CantataOfTaluviasAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class CantataOfTaluviasAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CantataOfTaluvias;
        this.__typeName = "CantataOfTaluvias";
    }
}
exports.CantataOfTaluviasAbilityArgs = CantataOfTaluviasAbilityArgs;
let CantataOfTaluviasActorAbilityFactory = class CantataOfTaluviasActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CantataOfTaluvias", "AllAllies", 4);
    }
};
CantataOfTaluviasActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CantataOfTaluvias")
], CantataOfTaluviasActorAbilityFactory);
exports.CantataOfTaluviasActorAbilityFactory = CantataOfTaluviasActorAbilityFactory;
let CantataOfTaluviasAbilityHandler = class CantataOfTaluviasAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
                for (const ally of allies) {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: ally,
                        duration: Duration_1.Duration.Ticks(4),
                        effect: new core_1.LinkedEventHandlerEffectArgs("Taluvias' Composition", "Healing all allies for 5% of max hp per tick", false, container.registerEventHandlerScript(ally, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, "HealAllAllies_OnTick", {
                            percentOfHealth: 5
                        }))
                    });
                }
            }
        });
    }
};
CantataOfTaluviasAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CantataOfTaluvias)
], CantataOfTaluviasAbilityHandler);
exports.CantataOfTaluviasAbilityHandler = CantataOfTaluviasAbilityHandler;
